export default {
  subject: (repair) => `Maintenence Notification`,
  body: (repair) => `
  <p><em>Dear ${repair.house.owner_firstname}:</em></p>

  <p>Thank you for trusting Unity Property Management as your property manager for the house at ${repair.showStreetAddress}.</p>

  <p>Currently, we got a maintenence issue on it as described as:</p>

  <p>${repair.description}</p>

  <p>By law, you have the responsibilty for maintenence of your house unless it is an issue cause on tenant side.</p>

  <p>You could fix it by yourself or we can find a handyman to help.</p>

  <p>Please reply to this email/message and tell me your decision.  Looking forward to discuss it with you very soon.</p>

  <p>Have a good day!</p>

<p>Your property manager,</p>
<p>Unity Property Management</p>
  `,
}
